import type { NodeDefinition } from '../../../types/node-definition';

/**
 * Agent Output Parser Sub-Node
 * 
 * This is a sub-node that enforces structured JSON output from AI agents.
 * It validates model outputs against a schema and retries if needed.
 * 
 * Parameters (defined in schema.ts):
 * - schemaSource: How to define schema (example or manual)
 * - jsonExample: Example JSON for auto-schema generation
 * - jsonSchema: Manual JSON Schema definition
 * - schemaDescription: Description of schema purpose
 * - strictValidation: Enforce strict validation
 * - enableAutoFix: Auto-fix common JSON errors
 * - enableRetry: Retry with LLM on validation failure
 * - maxRetries: Maximum retry attempts
 * - retryPromptTemplate: Template for retry prompts
 * - onValidationFailure: Action on final failure
 * - includeMetadata: Include validation metadata
 */
export const agentOutputParserDefinition: NodeDefinition = {
  type: 'agentOutputParser',
  name: 'Agent Output Parser',
  category: 'ai',
  description: 'Enforces structured JSON output from AI agents with validation and auto-retry',
  icon: 'FileJson',
  color: 'orange',
  version: '1.0.0',
  
  // Mark as sub-node
  isSubNode: true,
  subNodeConfig: {
    category: 'parser',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one parser per AI Agent
  },
  
  group: ['ai'],
  
  // Sub-nodes don't have traditional inputs/outputs
  inputs: [],
  outputs: [],
  
  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Chat Model',
        multiple: false,
        acceptTypes: ['anthropic', 'openai']
      }
    ]
  },
  
  credentials: [],
  
  defaults: {
    name: 'Agent Output Parser',
    color: 'orange'
  }
};

export default agentOutputParserDefinition;
